import { TRANSLATED_CONTRACT_STATUS } from '@/modules/contract/entities/contants/contract';
import { CONTRACT_STATUS } from '@/modules/contract/entities/enums/contract';
import { Contract } from '@/modules/contract/entities/interfaces/contract';
import React from 'react';
import { Chip } from 'vkit/lib/components';
import { Color } from 'vkit/lib/shared/types';

interface ContractStatusProps {
  contract: Contract;
}

const chipColors: Record<CONTRACT_STATUS, Color> = {
  [CONTRACT_STATUS.ACTIVE]: 'success',
  [CONTRACT_STATUS.CANCELLED]: 'danger',
  [CONTRACT_STATUS.EXPIRED]: 'warning',
};

const ContractStatus: React.FC<ContractStatusProps> = ({ contract }) => {
  return (
    <Chip
      size='small'
      label={TRANSLATED_CONTRACT_STATUS[contract.status]}
      rounded
      color={chipColors[contract.status]}
    />
  );
};

export default ContractStatus;
